import { render, staticRenderFns } from "./DeficiencyStatusIndicator.vue?vue&type=template&id=4609370b&"
import script from "./DeficiencyStatusIndicator.vue?vue&type=script&lang=js&"
export * from "./DeficiencyStatusIndicator.vue?vue&type=script&lang=js&"
import style0 from "./DeficiencyStatusIndicator.vue?vue&type=style&index=0&id=4609370b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports